
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateLetsEncryptCertificateForm from '@/services/SSL/forms/CreateLetsEncryptCertificateForm';
import { CertificateInterface, CertificatesRepositoryInterface } from '@/services/SSL/interfaces';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WebsitePicker from '../website/WebsitePicker.vue';
import OriginVhostRepositoryInterface from '@/services/Vhost/Origin/Interfaces';

@Component({
  inject: [
    'certificateRepository',
    'originVhostRepository',
  ],
  components: {
    WebsitePicker,
  },
})
export default class CreateLetsEncryptCertificate extends Vue {
  public $refs!: { 'w-picker': HTMLFormElement };

  @Prop({ required: false }) private readonly certificate!: CertificateInterface;

  private readonly certificateRepository!: CertificatesRepositoryInterface;

  private readonly originVhostRepository!: OriginVhostRepositoryInterface;

  public form: WPXFormValue<CreateLetsEncryptCertificateForm> = new WPXFormValue(CreateLetsEncryptCertificateForm);

  public aliases: string[] = [];

  public created(): void {
    if (!this.certificate) {
      return;
    }

    this.form.data.websiteId = this.certificate.websiteId;
    this.form.data.subDomains = (this.certificate.altNames as unknown as {
      name: string
    }[]).map((altName) => altName.name);
    this.form.data.autoRenew = this.certificate.autoRenew;
    this.form.data.vhostAliases = this.certificate.vhostAliases;
    this.form.data.email = this.form.data.email === '' ? undefined : this.form.data.email;
  }

  public mounted(): void {
    if (!this.certificate) {
      return;
    }

    this.$refs['w-picker'].websiteSearch = this.certificate.domain;
    this.loadAliases();
  }

  public get formValid(): boolean {
    this.form.valid = true;
    return !this.form.valid;
  }

  public async createCertificate(): Promise<void> {
    try {
      await this.certificateRepository.createLestEncryptCertificate(
        this.form.data.websiteId,
        this.form.data.subDomains,
        this.form.data.autoRenew,
        this.form.data.vhostAliases,
        this.form.data.email === '' ? undefined : this.form.data.email,
      );

      this.$successDialog.show('LetsEncrypt Certificate Creation Started');
      await this.$router.push({ name: 'certificate_all' });
    } catch (err) {
      if (err instanceof Error) {
        this.$errorDialog.show([err.message]);
      } else {
        console.error(err);
        this.$errorDialog.show('Unknown error appeared. Please try again later.');
      }
    }
  }

  @Watch('form.data.subDomains')
  public addNewAlias(aliases: string[]): void {
    if (aliases.length <= this.aliases.length) {
      return;
    }

    this.aliases = aliases;
  }

  public async loadAliases(): Promise<void> {
    try {
      const vhost = await this.originVhostRepository.getVhostByWebsiteId(this.form.data.websiteId);
      this.aliases = vhost.aliases.map((vhostAlias) => vhostAlias.alias);
    } catch (err) {
      this.$infoDialog.show(`Vhost aliases failed to load! ${err.message}`);
      this.aliases = [];
    }
  }
}
